import React, { useCallback } from 'react';
import { CrudForm, CrudStyles } from '../shared/Crud';
import { useForm } from '../../hooks/useForm';
import costCenterService from '../../services/costCenterService';

const { FormGroup, FormRow, Input, SectionTitle } = CrudStyles;

const initialFormData = {
    name: '',
    code: '',
};

function validateCostCenter(data) {
    const err = {};
    if (!data.name?.trim()) {
        err.name = 'Nome é obrigatório';
    }
    return err;
}

/**
 * Formulário de criação de centro de custo (nome obrigatório, código opcional).
 */
export default function CostCenterCreateForm({ customerId, onSuccess, onCancel }) {
    const submit = useCallback(
        async (data) => {
            const payload = {
                name: data.name.trim(),
                code: data.code?.trim() ? data.code.trim() : null,
            };
            await costCenterService.create(customerId, payload);
            onSuccess?.();
        },
        [customerId, onSuccess],
    );

    const { formData, errors, handleChange, handleSubmit, isSubmitting } = useForm(
        initialFormData,
        submit,
        validateCostCenter,
    );

    return (
        <CrudForm title="Novo centro de custo" onSubmit={handleSubmit} onCancel={onCancel} isSubmitting={isSubmitting}>
            <SectionTitle>Dados do centro de custo</SectionTitle>
            <FormRow>
                <FormGroup>
                    <label htmlFor="cost-center-create-name">Nome *</label>
                    <Input
                        id="cost-center-create-name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        $hasError={!!errors.name}
                        autoComplete="off"
                    />
                    {errors.name && <span className="error">{errors.name}</span>}
                </FormGroup>
                <FormGroup>
                    <label htmlFor="cost-center-create-code">Código</label>
                    <Input
                        id="cost-center-create-code"
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        $hasError={!!errors.code}
                        autoComplete="off"
                    />
                    {errors.code && <span className="error">{errors.code}</span>}
                </FormGroup>
            </FormRow>
            {errors.submit && (
                <span className="error" style={{ display: 'block', marginTop: 8 }}>
                    {errors.submit}
                </span>
            )}
        </CrudForm>
    );
}
